import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Login from './pages/Admin/Login';
import Dashboard from './pages/Admin/Dashboard';
import EditHero from './pages/Admin/EditHero';
import EditAbout from './pages/Admin/EditAbout';
import ManageProjects from './pages/Admin/ManageProjects';
import EditContact from './pages/Admin/EditContact';
import ChangePassword from './pages/Admin/ChangePassword';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin/dashboard" element={<Dashboard />} />
          <Route path="/admin/hero" element={<EditHero />} />
          <Route path="/admin/about" element={<EditAbout />} />
          <Route path="/admin/projects" element={<ManageProjects />} />
          <Route path="/admin/contact" element={<EditContact />} />
          <Route path="/admin/change-password" element={<ChangePassword />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;